<template>
  <div class="risk-imgs">
    <img :src="img" alt="" v-for="(img, i) in imgList" :key="i">
  </div>
</template>
<script>
import apiNsale from "@/utils/nsaleApi.js"
export default {
  data() {
    return {
      imgList: [],
    };
  },
  created(){
    const { id, no } = this.$route.query
    this.policyId = id
    this.policyNo = no
    this.getPolicyRiskNotify()
  },
  methods:{
    // 获取风险告知函内容
    getPolicyRiskNotify() {
      apiNsale.getPolicyRiskNotify(this.policyNo)
        .then(res => res.data)
        .then(res => {
            if(res.returnCode === '0000') {
                this.imgList = res.content.riskNotifyUrlList
            }
        })
    },

  }
}
</script>
<style lang="scss" scoped>
.risk-imgs{
    padding: 20px;
    img{
        max-width: 100%;
        margin-bottom: 12px;
    }
}
</style>